import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";
import { DashboardCard } from "src/components/common";
import { client } from "src/common/axiosClient";
import moment from "moment";

const ChatWeekly = () => {
  // chart color
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const primarylight = theme.palette.grey[100];
  const [reservation, setReservation] = useState<any[]>([]);
  const [weeklyData, setWeeklyData] = useState<number[]>([]);

  useEffect(() => {
    getDoctorReservations();
  }, []);

  const getDoctorReservations = async () => {
    const today = new Date();
    const day = today.getDay();
    const diffToMonday = today.getDate() - day + (day === 0 ? -6 : 1);
    const monday = new Date(today.setDate(diffToMonday));
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    const from = monday.toISOString().split("T")[0];
    const to = sunday.toISOString().split("T")[0];

    const response = await client.get(
      `admin/api/v1/reservation/MANUAL_THERAPIST/period?from=${from}&to=${to}`
    );

    if (response.status === 200) {
      setReservation([...response.data.content]);
      processWeeklyData(response.data.content, monday);
    } else {
      console.log(response);
    }
  };

  const processWeeklyData = (reservations: any[], startOfWeek: Date) => {
    const weeklyCounts = Array(7).fill(0); // Initialize an array with 7 zeros

    reservations.forEach((reservation) => {
      const dayOfWeek = moment(reservation.reservedAt).diff(
        startOfWeek,
        "days"
      ); // Get the day of the week (0-6)
      if (dayOfWeek >= 0 && dayOfWeek < 7) {
        weeklyCounts[dayOfWeek]++;
      }
    });

    setWeeklyData(weeklyCounts);
  };

  // chart
  const optionscolumnchart: any = {
    chart: {
      type: "bar",
      fontFamily: "'Plus Jakarta Sans', sans-serif;",
      foreColor: "#adb0bb",
      toolbar: {
        show: false,
      },
      height: 300,
    },
    colors: [primary, primary, primary, primary, primary, primary, primary],
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "45%",
        distributed: true,
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    xaxis: {
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
    tooltip: {
      theme: theme.palette.mode === "dark" ? "dark" : "light",
    },
  };

  const seriescolumnchart = [
    {
      name: "Reservations",
      data: weeklyData,
    },
  ];

  return (
    <DashboardCard title="주간 환자예약" subtitle="이번 주 기준">
      <Chart
        options={optionscolumnchart}
        series={seriescolumnchart}
        type="bar"
        height="375px"
      />
    </DashboardCard>
  );
};

export default ChatWeekly;
